<template>
  <div class="order-page">
    <combine-pay-btn />

    <div id="order-container"
         v-infinite-scroll="getOrderList"
         :infinite-scroll-disabled="isLoading || isEnd"
         infinite-scroll-distance="10">
      <router-link v-for="order in orderList"
                   :to="{name: 'orderDetail', params: {order_id: order['id']}}"
                   tag="div"
                   class="_card-wrap"
                   :key="order.id">
        <order-card :view-data="order" />
      </router-link>
      <div class="loadingpos">
        <loading v-show="isLoading" :no-transition="true" :show="true">获取数据</loading>
      </div>
      <div class="_empty"
           v-if="!isLoading && !orderList.length"> - 没有数据 - </div>
    </div>

  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import { mapActions,mapState } from 'vuex';
import OrderCard from "../components/OrderCard";
import CombinePayBtn from "../components/CombinePayBtn";
import Loading from "../components/Loadingb";

export default {
  components: { CombinePayBtn, OrderCard,Loading },
  data () {
    return {
      orderList: [],
      isLoading: false,
      isEnd: false,
      combineListParams: {
        page: 0,
        per_page: 20,
        total_required: true,
      },
    };
  },
  computed:{
    ...mapState(['actiBol'])
  },
  activated(){
    if(this.actiBol){
      this.isEnd = false;
      this.orderList = [];
      this.combineListParams= {
        page: 0,
        per_page: 20,
        total_required: true,
      },
      this.getOrderList();
    }
  },
  methods: {
    ...mapActions(['getPrintList']),
    getOrderList () {
      if (this.isLoading || this.isEnd) return
      console.log('ooooo');
      let params = {
        ...this.combineListParams,
        page: this.combineListParams.page + 1,
      }
      this.isLoading = true

      return this.getPrintList(params)
        .then(({ data }) => {
          if (data.length === 0)
            return this.isEnd = true;
          let orders = data
          this.orderList.push(...data)
          this.$set(this, 'combineListParams', params)
        })
        .then(() => {
          this.isLoading = false
        })
    },
  },
};
</script>

<style scoped>
.order-page {
  padding: 0.16rem 0 1.16rem;
}
#combine {
  position: fixed;
  bottom: 1.98rem;
  right: 0.16rem;
  width: 0.6rem;
  height: 0.6rem;
}

._card-wrap {
  box-sizing: border-box;
  margin: 0 auto 0.08rem;
  background-color: #fff;
  border-radius: 0.05rem;
  width: 3.43rem;
  padding: 0.16rem;
}

.spec-name {
  font-size: 0.16rem;
  color: #363636;
}

.order-id {
  font-size: 0.12rem;
  color: rgba(54, 54, 54, 0.5);
}

._empty {
  font-size: 0.14rem;
  color: rgba(54, 54, 54, 0.5);
  text-align: center;
}

#no-order {
  font-size: 0.14rem;
  color: rgba(54, 54, 54, 0.5);
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
